import { useQuery, useMutation } from "@apollo/client";
import {
  GET_USER_DEPOSIT_BALANCE,
  GET_USER_DEPOSIT_CHARGES,
  CREATE_DEPOSIT_CHARGE_ORDER,
  CREATE_CAMPAIGN_PARTICIPATION_WITHOUT_CHARGE,
  CANCEL_DEPOSIT_CHARGE,
  CANCEL_PARTICIPATION,
} from "../api/campaign-payment";

export const useDepositBalance = () => {
  const { data, loading, error, refetch } = useQuery(GET_USER_DEPOSIT_BALANCE, {
    fetchPolicy: "cache-and-network",
  });

  return {
    balance: data?.userDepositBalance || 0,
    loading,
    error,
    refetch,
  };
};

export const useDepositCharges = () => {
  const { data, loading, error, refetch } = useQuery(GET_USER_DEPOSIT_CHARGES, {
    fetchPolicy: "cache-and-network",
  });

  return {
    charges: data?.userDepositCharges || [],
    loading,
    error,
    refetch,
  };
};

export const useCreateDepositChargeOrder = () => {
  const [createDepositChargeOrder, { loading, error }] = useMutation(
    CREATE_DEPOSIT_CHARGE_ORDER
  );

  return {
    createDepositChargeOrder,
    loading,
    error,
  };
};

export const useCreateCampaignParticipationWithoutCharge = () => {
  const [createCampaignParticipationWithoutCharge, { loading, error }] =
    useMutation(CREATE_CAMPAIGN_PARTICIPATION_WITHOUT_CHARGE);

  return {
    createCampaignParticipationWithoutCharge,
    loading,
    error,
  };
};

export const useCancelDepositCharge = () => {
  const [cancelDepositCharge, { loading, error }] = useMutation(
    CANCEL_DEPOSIT_CHARGE,
    {
      refetchQueries: [
        { query: GET_USER_DEPOSIT_CHARGES },
        { query: GET_USER_DEPOSIT_BALANCE },
      ],
    }
  );

  return {
    cancelDepositCharge,
    loading,
    error,
  };
};

export const useCancelParticipation = () => {
  const [cancelParticipation, { loading, error }] = useMutation(
    CANCEL_PARTICIPATION,
    {
      refetchQueries: [{ query: GET_USER_DEPOSIT_BALANCE }],
    }
  );

  return {
    cancelParticipation,
    loading,
    error,
  };
};
